import { Compass, ExternalLink } from "lucide-react";
import { estComplet } from "@/components/EventCard";

export const EventCta = ({ event, config, onBook, testid = "event-cta", tone = "light", className = "" }) => {
  const complet = estComplet(event);
  const voyage = event.type === "voyage";
  const salon = event.type === "salon";
  const dark = tone === "dark";
  const base = `min-h-12 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm tracking-wide transition-colors duration-300 ${className}`;
  const primary = dark ? "bg-terra text-earth hover:bg-sand hover:text-earth" : "bg-terra text-earth hover:bg-earth hover:text-sand";
  const secondary = dark ? "bg-sand text-earth hover:bg-terra" : "bg-earth text-sand hover:bg-terra hover:text-earth";
  const closed = dark ? "bg-sand/15 text-sand/60 cursor-not-allowed" : "bg-sand-dark text-fumee cursor-not-allowed";

  if (event.passe) return <span className={`${base} ${closed}`} data-testid={`${testid}-passe`}>Événement passé</span>;
  if (event.annule) return <span className={`${base} ${closed}`} data-testid={`${testid}-annule`}>Événement annulé</span>;
  if (salon) return event.lien_externe ? (
    <a href={event.lien_externe} target="_blank" rel="noopener noreferrer" className={`${base} ${dark ? "border border-sand/40 text-sand hover:border-terra hover:text-terra" : "border border-wood/30 text-bark hover:border-terra hover:text-terra"}`} data-testid={testid}>
      {config.cta} <ExternalLink className="w-4 h-4" />
    </a>
  ) : null;
  if (voyage && !event.lien_externe) return <span className={`${base} ${closed}`} data-testid={`${testid}-voyage-indisponible`}>Préinscription bientôt disponible</span>;
  if (voyage) return (
    <a href={event.lien_externe} target="_blank" rel="noopener noreferrer" className={`${base} ${secondary}`} data-testid={testid}>
      {config.cta} <ExternalLink className="w-4 h-4" />
    </a>
  );
  if (event.reserve_parcours) return (
    <button type="button" onClick={() => onBook(event)} className={`${base} ${secondary}`} data-testid={testid}>
      {config.cta} <Compass className="w-4 h-4" />
    </button>
  );
  return (
    <button type="button" onClick={() => onBook(event)} disabled={complet} className={`${base} ${complet ? closed : primary}`} data-testid={testid}>
      {complet ? "Complet" : config.cta}
    </button>
  );
};